// import React from 'react';
import { Outlet } from "react-router-dom";



const NoAuthLayout = () => {
    // React.useEffect(() => {
    //     console.log("AuthLayout Mounted");
    // }, [])
    return <>
        
            <Outlet />
        
        
    </>
    
}

export default NoAuthLayout;